<template>
  <div>
    <upload-photo
      class="sidebar-upload-box__preview"
      :url="'/api/v1/uploads'"
      :style="customStyle"
      :preview="preview"
      @input="uploadDone"
      @change-preview="changePreview"
      @picture-selected="pictureSelected"
    />

    <p>
      <span
        class="sidebar-upload-box__footnote"
        :class="{
          'sidebar-upload-box__footnote--error': !imageUploaded,
        }"
      >
        {{ imageUploaded ? successMessage : errorMessage }}
      </span>
    </p>

    <p>
      <span
        v-if="foundationDefaultPictures.length"
        class="sidebar-upload-box__footnote"
        :class="{
          'sidebar-upload-box__footnote--error': !imageUploaded,
        }"
      >
        {{ defaultPhotoMessage }}
      </span>
    </p>

    <div class="default-photo-container">
      <img
        v-for="item in foundationDefaultPictures"
        class="default-photo"
        :src="item.url"
        :key="item.id"
        @click="defaultClicked(item)">
    </div>
  </div>
</template>

<script>
import UploadPhoto from '../upload-photo/upload-photo.vue';

export default {
  components: { UploadPhoto },
  props: {
    url: { type: String, required: true },
    customStyle: { type: String, required: false, default: '' },
    foundationDefaultPictures: { type: Array, required: true },
    value: { type: Object, required: true },
    imageUploaded: { type: Boolean, required: true },
    successMessage: { type: String, required: true },
    errorMessage: { type: String, required: true },
    defaultPhotoMessage: { type: String, required: true },
  },
  data() {
    return {
      preview: null,
    };
  },
  methods: {
    uploadDone(uploadIdentifier) {
      this.$emit('input', {
        ...this.value,
        uploadIdentifier,
        pictureId: null,
      });
    },
    defaultClicked(picture) {
      this.preview = picture.url;
      this.$emit('input', {
        ...this.value,
        uploadIdentifier: null,
        pictureId: picture.id,
      });
    },
    changePreview(preview) {
      this.preview = preview;
    },
    pictureSelected(file) {
      this.$emit('picture-selected', file);
    },
  },
};
</script>
